import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=88008e16&"
import script from "./LoginPhone.vue?vue&type=script&lang=ts&"
export * from "./LoginPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports